import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { AlertCircle, X, Mail } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

function VerificationBanner() {
  const { user, refreshUser } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);

  // Check if banner should show
  const shouldShow = user && user.email_verified === false && !dismissed;
  
  console.log('[VerificationBanner] User:', user?.email, 'Verified:', user?.email_verified, 'Show:', shouldShow);

  // Don't show if user is verified or banner is dismissed
  if (!shouldShow) {
    return null;
  }

  const handleResendEmail = async () => {
    setResending(true);
    try {
      console.log('📧 Resending verification email...');
      // Call backend to resend verification email
      await axios.post(`${API}/api/auth/resend-verification`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      console.log('✅ Verification email sent');
      toast.success('Verification email sent! Check your inbox.');
    } catch (error) {
      console.error('❌ Failed to resend:', error);
      toast.error('Failed to resend email. Please try again.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      color: 'white',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      position: 'relative',
      zIndex: 1000
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
        <AlertCircle size={20} />
        <div>
          <span style={{ fontWeight: '600', fontSize: '14px' }}>
            Please verify your email address
          </span>
          <span style={{ fontSize: '13px', marginLeft: '8px', opacity: 0.9 }}>
            Check your inbox for the verification link.
          </span>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button
          onClick={handleResendEmail}
          disabled={resending}
          style={{
            background: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            padding: '6px 12px',
            borderRadius: '6px',
            fontSize: '13px',
            fontWeight: '500',
            cursor: resending ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            opacity: resending ? 0.6 : 1
          }}
        >
          <Mail size={14} />
          {resending ? 'Sending...' : 'Resend Email'}
        </button>

        <button
          onClick={() => setDismissed(true)}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            opacity: 0.8
          }}
          aria-label="Dismiss"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}

export default VerificationBanner;
